import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Checkbox } from './ui/checkbox';

export function EditSponsorDialog({ sponsor, isOpen, onClose, onSave }) {
  const [formData, setFormData] = useState({
    name: '',
    category: 'other',
    active: true,
    });

  useEffect(() => {
    if (sponsor) {
      setFormData({
        name: sponsor.name || '',
        category: sponsor.category || 'other',
        active: sponsor.active !== undefined ? sponsor.active : true,
      });
    }
  }, [sponsor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };


  const handleCheckboxChange = (checked) => {
    setFormData(prev => ({ ...prev, active: checked }));
  };

  const handleSelectChange = (value) => {
    setFormData(prev => ({ ...prev, category: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Sponsor</DialogTitle>
          <DialogDescription>
            Update the sponsor information. Click save when you're done.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                Name
              </Label>
              <Input
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="col-span-3"
                required
              />
            </div>
            
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="category" className="text-right">
                Category
              </Label>
              <Select 
                value={formData.category} 
                onValueChange={handleSelectChange}
              >
                <SelectTrigger className="col-span-3">
                  <SelectValue placeholder="Select category" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="kit_sponsor">Kit Sponsor</SelectItem>
                  <SelectItem value="main_sponsor">Main Sponsor</SelectItem>
                  <SelectItem value="pitchside_advertising">Pitchside Advertising</SelectItem>
                  <SelectItem value="digital_media">Digital Media</SelectItem>
                  <SelectItem value="community_partner">Community Partner</SelectItem>
                  <SelectItem value="event_sponsor">Event Sponsor</SelectItem>
                  <SelectItem value="official_supplier">Official Supplier</SelectItem>
                  <SelectItem value="other">Other</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="flex items-center space-x-2 mt-4">
              <Label htmlFor="active" className="text-right">
                Active
              </Label>
              <div className="flex items-center space-x-2 col-span-3">
                <Checkbox 
                  id="active" 
                  checked={formData.active}
                  onCheckedChange={handleCheckboxChange}
                />
                <label
                  htmlFor="active"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  Sponsor is active
                </label>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button type="submit">Save changes</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
